export const menuItems = [
    {
        label: 'Home',
        url: '#',
        cName: 'nav-links'
    },
    {
        label: 'About',
        url: '#',
        cName: 'nav-links'
    },
    {
        label: 'Service',
        url: '#',
        cName: 'nav-links'
    },
    {
        label: 'Contact',
        url: '#',
        cName: 'button'
    },
]

export default menuItems